// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1J1oC","inner":"Footer_inner__1oDO0","nextIcon":"Footer_nextIcon__1FQoa","innerLeft":"Footer_innerLeft__3IPRu"};